import React from 'react';
import Contact from '../components/sections/Contact';
import HeadMeta from '../components/common/HeadMeta';
import Faqs from '@/components/sections/Faqs';
import { fetchFaqs } from '@/lib/apiCalls';

export default function contact({ faqs }) {
  const metaProps = {
    title: 'Contáctame en Entre Coach - Julie Ann De Armas te Ayuda',
    keywords:
      'Contacto Entre Coach, Julie Ann De Armas, Asesoramiento Personal, Sesiones de Coaching, Consulta Profesional',
    description:
      'Contáctame en Entre Coach para iniciar tu camino hacia el éxito y el bienestar con Julie Ann De Armas. Responde a todas tus preguntas y recibe asesoramiento personalizado.',
  };
  return (
    <>
      <HeadMeta {...metaProps} />
      <Contact />
      <Faqs data={faqs} />
    </>
  );
}

export async function getServerSideProps() {
  const [faqs] = await Promise.all([fetchFaqs()]);

  return {
    props: {
      faqs,
    },
  };
}
